import { Component } from 'preact'

import getWithInMemoryCache from '../../utils/getWithInMemoryCache'
import KnowledgeBaseNavigation from './navigation'

export default class extends Component {
  constructor () {
    super()
    this.state = {
      categories: []
    }
  }

  componentDidMount () {
    getWithInMemoryCache('/site/knowledgeBase', {})
      .then(data => this.setState({ categories: data.categoryGroups }))
  }

  render ({ currentParent, currentCategory }) {
    return <KnowledgeBaseNavigation
      currentCategory={currentCategory}
      currentParent={currentParent}
      categories={this.state.categories}
    />
  }
}
